module.exports = __webpack_public_path__ + "img/logo.e8b85d4a.png";